import { render, staticRenderFns } from "./DefaultData.vue?vue&type=template&id=3ca50d76&scoped=true"
var script = {}
import style0 from "./DefaultData.vue?vue&type=style&index=0&id=3ca50d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca50d76",
  null
  
)

export default component.exports